import { ICON_SIZE } from '../Icon'

export const AVATAR_HEIGHT_16 = 16

export const AVATAR_HEIGHT_20 = 20

export const AVATAR_HEIGHT_24 = 24

export const AVATAR_HEIGHT_32 = 32

export const AVATAR_HEIGHT_40 = 40

export const AVATAR_HEIGHT_48 = 48

export const AVATAR_HEIGHT_100 = 100

export const AVATAR_CLASS_ALIASES = {
  [AVATAR_HEIGHT_16]: 'size16',
  [AVATAR_HEIGHT_20]: 'size20',
  [AVATAR_HEIGHT_24]: 'size24',
  [AVATAR_HEIGHT_32]: 'size32',
  [AVATAR_HEIGHT_40]: 'size40',
  [AVATAR_HEIGHT_48]: 'size48',
  [AVATAR_HEIGHT_100]: 'size100',
}

export const QA_NAME_AVATAR_DEFAULT = 'avatar'

export const AVATAR_ICON_SIZE_MAP = {
  [AVATAR_HEIGHT_16]: ICON_SIZE.size12,
  [AVATAR_HEIGHT_20]: ICON_SIZE.size20,
  [AVATAR_HEIGHT_24]: ICON_SIZE.size16,
  [AVATAR_HEIGHT_32]: ICON_SIZE.size20,
  [AVATAR_HEIGHT_40]: ICON_SIZE.size24,
  [AVATAR_HEIGHT_48]: ICON_SIZE.size28,
  [AVATAR_HEIGHT_100]: ICON_SIZE.size100,
}
